import React, { useEffect } from 'react';
import { User } from 'lucide-react';
import PersonalInformation from '../profile/PersonalInformation';
import { usePageHeader } from '../../contexts/PageHeaderContext';

const ManagerPersonalOverview = () => {
  const { setHeader } = usePageHeader();

  useEffect(() => {
    setHeader({
      icon: User,
      title: 'Personal Information',
      subtitle: 'As a line manager, review and update your own personal, employment, and position information.',
    });
    return () => setHeader({ icon: null, title: '', subtitle: '' });
  }, [setHeader]);

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">

      {/* Reuse the same tabbed personal information view as for employees */}
      <PersonalInformation hideHeader={true} />
    </div>
  );
};

export default ManagerPersonalOverview;


